module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/catalogo-obras/catalogo-obras.component.scss
// module id = ./src/app/components/catalogo-obras/catalogo-obras.component.scss
// module chunks = main